import { create } from 'zustand';

const createDefaultResumeData = () => ({
  basics: {
    name: "",
    email: "",
    phone: "",
    headline: "",
    location: "",
    url: { href: "", label: "" },
    picture: { url: "" },
    customFields: [],
  },
  sections: {
    skills: {
      name: "Skills",
      items: [{ name: "", level: 3, visible: true }],
    },
    summary: { name: "Summary", content: "", visible: true },
    profiles: {
      name: "Profiles",
      items: [{ name: "", url: { href: "", label: "" } }],
    },
    projects: {
      name: "Projects",
      items: [{ name: "", description: "", skills: [""] }],
    },
    interests: { name: "Interests", items: [{ name: "" }] },
    languages: {
      name: "Languages",
      items: [{ name: "", level: 0, proficiency: "100%" }],
    },
    volunteer: {
      name: "Volunteering",
      items: [
        {
          position: "",
          company: "",
          location: "",
          date: "",
          summary: "",
          visible: true,
        },
      ],
    },
    experience: {
      name: "Experience",
      items: [
        {
          position: "",
          company: "",
          location: "",
          date: "",
          summary: "",
          missions: [""],
          visible: true,
        },
      ],
    },
    references: {
      name: "References",
      items: [],
      columns: 1,
      visible: true,
      separateLinks: true,
    },
    publications: {
      name: "Publications",
      items: [
        {
          name: "",
          description: "",
          issuer: "",
          date: "",
          url: { href: "", label: "" },
        },
      ],
    },
    certifications: {
      name: "Certifications",
      items: [
        {
          name: "",
          description: "",
          issuer: "",
          date: "",
          url: { href: "", label: "" },
        },
      ],
    },
    awards: {
      name: "Awards",
      items: [{ name: "", description: "", issuer: "", date: "" }],
    },
    education: {
      name: "Education",
      items: [
        {
          institution: "",
          studyType: "",
          area: "",
          date: "",
          summary: "",
          score: "",
          url: { href: "", label: "" },
        },
      ],
    },
    current_skills: {
      name: "Current Skills",
      items: [{ name: "", level: 3, visible: true }],
    },
    missing_skills: {
      name: "Missing Skills",
      items: [{ name: "", level: 3, visible: true }],
    },
    suggested_missions: {
      name: "Suggested Missions",
      items: [""],
    },
  },
});

const normalizeResumeData = (incomingData) => {
  if (!incomingData || typeof incomingData !== "object") {
    return null;
  }

  const defaults = createDefaultResumeData();
  const incomingSections = incomingData.sections || {};
  const normalizedSections = Object.keys(defaults.sections).reduce(
    (accumulator, sectionKey) => {
      const defaultSection = defaults.sections[sectionKey];
      const incomingSection = incomingSections[sectionKey];

      accumulator[sectionKey] =
        incomingSection && typeof incomingSection === "object"
          ? { ...defaultSection, ...incomingSection }
          : defaultSection;

      return accumulator;
    },
    {}
  );

  return {
    ...defaults,
    ...incomingData,
    basics: { ...defaults.basics, ...(incomingData.basics || {}) },
    sections: normalizedSections,
  };
};

export const useStore = create((set) => ({
  data: null,
  skills: {
    list1: [],
    list2: [],
  },
  missions: {
    list3: [],
    list4: [],
  },
  selectedTemplate: 'Template1',
  profilePicture: null,
  userData: {},
  loading: false,

  setData: (newData) => {
    const normalizedData = normalizeResumeData(newData);

    set(() => ({
      data: normalizedData,
      skills: {
        list1:
          normalizedData?.sections?.missing_skills?.items
            ?.map((item) => item?.name)
            .filter(Boolean) || [],
        list2:
          normalizedData?.sections?.current_skills?.items
            ?.map((item) => item?.name)
            .filter(Boolean) || [],
      },
    }))
  },
  setSkills: (skills) => {
      set((state) => ({
        skills: skills,
      }))
    },
  resetData: () => {
    localStorage.removeItem("uploadResponse");
    set({
      data: null,
      skills: {
        list1: [],
        list2: [],
      },
    });
  },
  setSelectedTemplate: (template) => set({ selectedTemplate: template }),
  setProfilePicture: (picture) => set({ profilePicture: picture }),
  setUserData: (user) => set(( state ) => ({ userData: { ...state.userData, ...user } })),
  setLoading: (value) => set(() => ({ loading: value }))
}));
